import React, { useState, useEffect } from 'react';
import { get_dlqi_plqi } from "../Services/Service";

function DLQI({ uuid }) {


    const [dlqiResponse, setDlqiResponse] = useState([]);

    useEffect(() => {
        const fetchDlqi = async () => {
            try {
                const dlqiResponse = await get_dlqi_plqi({ uuid: uuid, type: "dlqi" });
                console.log(dlqiResponse);
                setDlqiResponse(dlqiResponse.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchDlqi();
    }, [uuid]); // Run effect whenever `uuid` changes

    return (
        <>
            <div className='row'>
                {dlqiResponse.map(dlqiVal => (
                    <> {/* Add a unique key for each item */}
                        <div className='col-md-4 mt-4 border-start px-5'>
                            <div className='row align-items-center'>
                                <div className='col-auto'>
                                    <p className='person-subtitle mb-0'>{dlqiVal.date}</p>
                                </div>
                                <div className='col'>
                                    <p className='person-subtitle mb-0'>Click Here <a target="_blank" className='dliq-btn' href={dlqiVal.link}>OPEN </a></p>
                                </div>
                            </div>
                        </div>
                    </>

                ))}
            </div>
        </>
    );
}

export default DLQI;
